import { setup } from 'axios-cache-adapter';

export default setup({
    cache: {
        maxAge: 5 * 60 * 1000,
        exclude: { query: false }
    }
});



// WEBPACK FOOTER //
// ./src/axios.js